export default {

    //General phrases
    tollWord: 'Taкса за преминаване на мост Фетещ | Taкси за преминаване на мост Фетещ| Пеажи',
    vignetteWord: 'Винетка | Винетки',

    site_tpf: 'taxa-pod-fetesti.ro',
    site_erv: 'e-rovinieta.ro',

    currency: 'леи',
    category: 'категория',
    select_type_of_vehicle: 'Изберете вид превозно средство',
    select_the_period: 'Select the period',
    or_pay_for: 'Или заплати за',
    your_vehicles_link: 'Вашите автомобили',
    or_go_to_your_account_and_buy: 'Или влезте в своя профил и купете директно за своите коли',
    see_cart: 'Вижте кошницата',
    or: 'или',
    and: 'и',
    back: 'назад',
    total: 'Общо',
    pf: 'Физическо лице',
    pj: 'Юридическо лице',
    yes: 'Дa',
    no: 'Не',
    about: 'За',
    us: 'Ние',

    vignette: 'винетка | винетки',
    passing: 'преминаване | преминавания',

    toll_buy: 'Заплатете таксата за моста',
    vignette_buy: 'Заплатете винетката',

    //Order
    billing_add_new_profile: 'Добавете нов профил за фактуриране',

    cart_empty: 'Кошницата е празна',
    cart_available_from: 'Валидна от',
    cart_add_more: 'Продължавайте да добавяте в кошницата други',
    cart_continue_with_buying: 'Купи още',
    cart_validation_errors: 'Изключени от заявката продукти заради грешки във валидирането',

    order_container_place_order_title: 'Изпратете заявка',
    order_container_my_cart: 'Моята кошница',
    order_container_billing_info: 'Данни за фактуриране',
    order_container_payment: 'Плащане',

    payment_method_insuficient_credit: 'недостатъчен кредит',
    payment_method_instant_credit: 'Инстантен кредит',
    payment_method_instant_credit_description: 'Инстантен кредит',
    payment_method_credit_card: 'Oнлайн с банкова карта',
    payment_method_credit_card_description: 'плащането ще бъде обработено с PayU.ro',
    payment_method_iTransfer_description: 'Платежно нареждане c незабавно потвърждение',
    payment_method_payment_order: 'Платежно нареждане',
    payment_method_payment_order_description: 'Ще получите имейл проформа за покупката, съдържащ платежните разпореждания. Заявката се издава при получаване на плащането',
    payment_method_credit_erv: 'Кредит e-винетка',
    payment_method_credit_tpf: 'Кредит taкса мост Фетещ',
    payment_method_terms: 'Потвърждавам, че отбелязаните по-долу данни са правилни и че съм прочел и съм съгласен с общите условия',

    thank_you_placed_order_title: 'Пласирана заявка',
    thank_you_successful_order: 'Заявката успешно пласирана!',
    thank_you_see_info_order: 'Виж нейният статус в моите заявки',
    thank_you_my_orders: 'Моите заявки',

    //Account
    continue_with: 'Continue with',
    account_activate_header: 'Aктивирайте профила',
    account_activate_message: '',

    account_container_my_account: 'Моят профил',
    account_container_vehicles: 'Превозни средства',
    account_container_orders: 'Заявки',
    account_container_profiles: 'Профили фактуриране',
    account_container_info: 'Данни сметка',

    account_data_title: 'Детайли сметка',

    add_car_title: 'Добавяне автомобил',

    add_profile_title: 'Добавяне профил',
    add_profile_pj_extracted: 'Автоматично извлечени данни юридическо лице',

    edit_car_no_vehicles: 'Няма намерени превозни средства!',
    edit_car_delete_vehicle_title: 'Заличаване превозно средство',
    edit_car_delete_vehicle: 'Сигурен ли сте, че желаете да заличите това превозно средство?',

    my_orders_passings: 'едно преминаване | {count} преминавания',

    profiles_main: 'Главен',
    profiles_secondary: 'Второстепенен',
    profiles_unverified_data: 'Непроверени данни',
    profiles_no_profile: 'Няма нито един профил',
    profiles_delete_profile: 'Заличете профила',
    profiles_are_you_sure: 'Сигурен ли сте, че желаете да заличите профила?',

    //Authentication
    login_auth: 'Логване',
    login_login_into_your_account: 'Влезте в своя профил',

    login_component_login_by: 'Логване с',
    login_component_no_account: 'Нямате ли профил?',
    login_component_forgot_password: 'Забравена парола?',

    new_account_title: 'Нов профил',
    new_account_details: 'Детайли на профила',
    new_account_ive_read: 'Прочетох и съм съгласен с',
    new_account_tc: 'Общи условия',
    new_account_site: 'на сайта',
    new_account_pc: 'Политика за поверителност',
    mandatory: 'Задължителен',
    new_account_must_accept_tc: 'Трябва да се съгласите с общите условия',
    new_account_must_accept_pc: 'Трябва да се съгласите с политиката за поверителност',

    contact_title: 'Договор',

    header_how_does_it_work: 'Как работи?',

    how_it_works_p1: 'Тръгвате за 3 минути!',
    how_it_works_p2: 'Лицензиран дистрибутор НКАПИ',
    how_it_works_p3: 'Онлайн поръчки на taxa-pod-fetesti.ro',

    toll_category_error_loading_car: 'Проблем при зареждане на автомобила',
    toll_category_error_loading_country: 'Проблем при зареждане на държавите',

    vignette_category_error_fromdate: 'Изберете датата, на която влиза в сила винетката',

    //Buttons
    btn_save: 'Запаметете',
    btn_save_changes: 'Запаметете измененията',
    btn_add_car: 'Добавете превозно средство',
    btn_delete_car: 'Заличете превозно средство',
    btn_next_step: 'Следваща стъпка',
    btn_finish: 'Приключване',
    btn_grab_data_company: 'Поемете данни <br/> Търговски регистър',
    btn_add_profile: 'Добавете нов профил',
    btn_i_understand: 'Разбрах',
    btn_login: 'Логване',
    btn_register: 'Запишете се',
    btn_create_account: 'Създадете профил',
    btn_add_to_cart: 'Добавете в кошницата',
    btn_edit_to_cart: 'Модифицирайте продукта',
    btn_reset_password: 'Нулирайте паролата',
    btn_bill: 'Factureaza',
    btn_choose_payment_method: 'Choose payment method',


    //Labels
    label_email: 'Имейл',
    label_password: 'Парола',
    label_confirm_password: 'Потвърдете паролата',
    label_license_plate: 'Регистрационен номер',
    label_chasis_number: 'Рама шаси',
    label_registration_country: 'Държава на регистрация',
    label_motif: 'Причина за по-ниска категория',
    label_choose_category: 'Избери категория за',
    label_billing_type: 'Фактуриране на',
    label_last_name: 'Фамилно име',
    label_first_name: 'Име',
    label_country: 'Държава',
    label_county: 'Окръг',
    label_city: 'Град',
    label_address: 'Aдрес',
    label_cui: 'ЕИК',
    label_reg_com: 'Търговски регистър',
    label_locality: 'Град',
    label_company_name: 'Наименование компания',
    label_for_car: 'За превозното средство',
    label_available_from: 'Валидна от датата',

    //terms
    terms: 'Правила и условия',
    partners: 'партньор',

    delete_product_title: 'Delete product',
    delete_product: 'Are you sure you want to delete this product?',

    sms_notice: '<strong>Платена услуга за SMS известяване</strong><br/><br/>Услугата за известяване чрез изпращане на кратки текстови съобщения (SMS) позволява уведомяване на клиентите на www.taxa-pod-fetesti.ro за потвърждаване на издаването на такса за мост, респективно уведомяване на клиентите за изтичането на валидността на такса за мост. Услугата е по избор, според желанието на клиента, и е налична само за поръчки, платени онлайн чрез платежния процесор (PayU).<br/><br/> Коректността на данните и информацията в SMS-а относно издаването и/или изтичането на винетката, регистрационния номер, рамката и мобилния телефонен номер, въведени в платформата www.taxa-pod-fetesti.ro, са изцяло отговорност на потребителя .<br/><br/> SMS известяването се извършва чрез NETOPIA Payments.<br/><br/> Системата за SMS известяване изпраща известия до клиентите, които избират тази услуга. Получаването на SMS-ите относно потвърждаване/изтичане може да бъде повлияно от работата и покритието на телекомуникационните мрежи, функционирането на използваните устройства и др.<br/><br/> За да се свържете с нас, моля, използвайте страницата за контакт на www.taxa-pod-fetesti.ro.<br/><br/>'

};
